import React from 'react';
import { Link } from 'react-router-dom';

import s from './ErrorPage.module.scss';

const Error = () => (
  <>
    <div className={s.ErrorPage}>
      <h2 className={s.Title}>
        Что-то пошло не так, попробуйте позже.
      </h2>
      <Link className={s.Link} to="/">На главную</Link>
    </div>
  </>
);

export default Error;
